import { queryOptions, useQuery } from '@tanstack/react-query';

import { conversationsApi } from '../api/conversations-api';

import { conversationKeys } from './conversation-keys';

export function visitorProfileQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: conversationKeys.visitor(storeId, id),
    queryFn: () => conversationsApi.visitor(storeId, id),
    // the page trail grows with every heartbeat (30 s) while the sheet is open
    refetchInterval: 30_000,
  });
}

export function useVisitorProfile(storeId: string, id: string) {
  return useQuery(visitorProfileQueryOptions(storeId, id));
}
